<div class="finance-access">
  <section class="finance-access__section">
    <div class="finance-access__heading">
      <div>
        <h3>Способы оплаты</h3>
        <p>Каналы, которые менеджер сможет выбирать при продаже.</p>
      </div>
    </div>

    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Платёжные каналы</mat-label>
      <mat-select [formControl]="paymentChannelControl" multiple>
        <mat-select-trigger>{{ selectedPaymentSummary }}</mat-select-trigger>
        <mat-optgroup *ngFor="let group of paymentChannelGroups" [label]="group.moneyType">
          <mat-option
            *ngFor="let bank of group.banks"
            [value]="bank"
            [disabled]="bank.isOperational === false && !isSelected(bank)"
          >
            <span class="finance-access__option">
              <strong>{{ bank.description }}</strong>
              <small>{{ channelMeta(bank) }}</small>
            </span>
          </mat-option>
        </mat-optgroup>
      </mat-select>
      <mat-hint *ngIf="!loading">Наличка настраивается отдельно как физический ящик.</mat-hint>
    </mat-form-field>
  </section>

  <section class="finance-access__section finance-access__section--cashbox">
    <div class="finance-access__heading">
      <div>
        <h3>Наличные ящики менеджера</h3>
        <p>Здесь видно, на какой точке физически хранятся деньги.</p>
      </div>
      <button mat-stroked-button color="primary" type="button" (click)="toggleCreateCashbox()">
        <mat-icon>{{ createCashboxOpened ? 'close' : 'add' }}</mat-icon>
        {{ createCashboxOpened ? 'Отмена' : 'Создать ящик' }}
      </button>
    </div>

    <div class="finance-access__empty" *ngIf="!loading && ownCashboxes.length === 0">
      У менеджера пока нет денежного ящика.
    </div>

    <div class="finance-access__cashboxes" *ngIf="ownCashboxes.length > 0">
      <label
        class="finance-access__cashbox"
        *ngFor="let bank of ownCashboxes"
        [class.finance-access__cashbox--inactive]="bank.isOperational === false"
      >
        <mat-checkbox
          [checked]="isSelected(bank)"
          [disabled]="bank.isOperational === false"
          (change)="toggleCashbox(bank, $event.checked)"
        ></mat-checkbox>
        <span class="finance-access__cashbox-copy">
          <strong>{{ bank.description }}</strong>
          <small>{{ cashboxMeta(bank) }}</small>
        </span>
        <span class="finance-access__cashbox-badge">Наличка</span>
      </label>
    </div>

    <div class="finance-access__create" *ngIf="createCashboxOpened">
      <app-warehouse-selector [control]="cashboxWarehouseControl"></app-warehouse-selector>
      <div class="finance-access__create-copy">
        Владелец и название будут заполнены автоматически. Если активный ящик на этой точке уже
        существует, он будет подключен без создания дубля.
      </div>
      <button
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="!canCreateCashbox"
        (click)="createCashbox()"
      >
        <mat-icon>add_box</mat-icon>
        {{ creatingCashbox ? 'Подключаем…' : 'Создать и подключить' }}
      </button>
    </div>
  </section>

  <section class="finance-access__legacy" *ngIf="unsupportedSelectedBanks.length > 0">
    <div class="finance-access__legacy-title">
      <mat-icon>warning_amber</mat-icon>
      Старые неоднозначные привязки
    </div>
    <p>
      Эти записи сохранены для совместимости, но не определяют физическую кассу менеджера. Их можно
      удалить из доступа.
    </p>
    <div class="finance-access__legacy-row" *ngFor="let bank of unsupportedSelectedBanks">
      <span>
        <strong>{{ bank.description }}</strong>
        <small
          >{{ bank.moneyType }} · {{ bank.warehouse?.description || 'точка не указана' }}</small
        >
      </span>
      <button
        mat-icon-button
        type="button"
        (click)="removeUnsupportedBank(bank)"
        title="Убрать привязку"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </section>
</div>
